import React from 'react';
import { SectionNavigationProps, MainNavProps, HeaderCtaProps } from 'libs/contentful/props';
import Nav from '../MainNav/Nav';
import HeaderCta from '../HeaderCTA/HeaderCta';

/**
 * Renders a navigation section that can contain a Nav component
 * Specifically used when we need to render different navigation modules in one Ninetailed experience
 * @param props - Props including the navigation content
 * @returns The rendered navigation section component
 */
const SectionNavigation = (props: SectionNavigationProps) => {
  const { nav } = props;

  if (!nav) {
    return null;
  }

  switch (nav.__typename) {
    case 'Nav':
      return <Nav {...(nav as MainNavProps)} />;
    case 'HeaderCta':
      return <HeaderCta {...(nav as HeaderCtaProps)} />;
    default:
      console.warn(`SectionNavigation: Unsupported navigation type: ${nav.__typename}`);
      return null;
  }
};

export default SectionNavigation;
